import React from 'react';
import { Cable, Zap, Shield, Award } from 'lucide-react';
import { features } from '../../mock';

const ICON_MAP = {
  "premium-quality": Shield,
  "safety-certified": Award,
  "wide-range": Cable,
  "expert-support": Zap,
};

export const Features = () => (
  <section className="py-20 px-4 bg-gradient-to-b from-black to-gray-900" data-testid="features-section">
    <div className="container mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((feature) => {
          const Icon = ICON_MAP[feature.id] || Shield;
          return (
            <div
              key={feature.id}
              className="p-6 border border-gray-800 rounded-lg hover:border-amber-500 transition-all hover:shadow-lg hover:shadow-amber-500/20"
              data-testid={`feature-card-${feature.id}`}
            >
              <Icon className="h-12 w-12 text-amber-500 mb-4" />
              <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
